"use client";
import {
	Drawer,
	DrawerContent,
	DrawerDescription,
	DrawerHeader,
	DrawerTitle,
	DrawerTrigger,
} from "@/components/ui/drawer";
import { MenuIcon, X } from "lucide-react";
import { type ReactNode, useEffect, useRef, useState } from "react";

export const NavMobileMenu = ({ children }: { children: ReactNode }) => {
	const [isOpen, setIsOpen] = useState(false);
	const contentRef = useRef<HTMLDivElement>(null);

	// Handle the content height and scrolling
	useEffect(() => {
		if (!isOpen || !contentRef.current) return;

		// Set a fixed height for the content area
		const updateHeight = () => {
			if (!contentRef.current) return;
			const viewportHeight = window.innerHeight;
			const headerHeight = 100; // Approximate header height
			const availableHeight = viewportHeight - headerHeight;
			contentRef.current.style.maxHeight = `${availableHeight}px`;
		};

		updateHeight();
		window.addEventListener("resize", updateHeight);

		return () => {
			window.removeEventListener("resize", updateHeight);
		};
	}, [isOpen]);

	return (
		<Drawer open={isOpen} onOpenChange={setIsOpen}>
			<DrawerTrigger>
				<MenuIcon />
			</DrawerTrigger>
			<DrawerContent>
				<div className="flex flex-col h-full">
					<DrawerHeader className="bg-black text-white font-[Amarante] flex-shrink-0">
						<div className="flex justify-between items-center p-4">
							<DrawerTitle className="headerFont text-4xl">Menú</DrawerTitle>
							<button
								onClick={() => setIsOpen(false)}
								className="text-red-500 hover:text-red-700 transition-colors"
							>
								<X size={32} />
							</button>
						</div>
						<DrawerDescription className="sr-only">Navigation menu</DrawerDescription>
					</DrawerHeader>
					<div
						ref={contentRef}
						className="bg-black mobile-menu overflow-y-auto"
						onClick={(e) => {
							if (e.target instanceof HTMLElement && e.target.closest("a")) {
								setIsOpen(false);
							}
						}}
					>
						{children}
					</div>
				</div>
			</DrawerContent>
		</Drawer>
	);
};
